rdefine('app/formular/components/ContainForms',['backbone','app/formular/components/DummyForm','app/formular/components/frm/Placeholder'],function(Backbone,DummyForm,PlaceholderModel) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'drag-components-form',
        bindings:{
            el: {
                collection: {
                    col: 'collection',
                    view: 'customview',
                    waterfallAdding: true
                }
            }
        },
        initialize:function() {
            this.$el.bind("dragover", _.bind(this._dragOverEvent, this))
            this.$el.bind("dragenter", _.bind(this._dragEnterEvent, this))
            this.$el.bind("dragleave", _.bind(this._dragLeaveEvent, this))
            this.$el.bind("drop", _.bind(this._dropEvent, this))
            this.$el.addClass(this.className);
            //console.log("containforms init");
            this._draghoverClassAdded = false;
            this.customview=_.bind(this._customView,this);
            this.collection.ebus.on("dragstart",_.bind(this._addDragEffect,this));
            this.collection.ebus.on("dragstop",_.bind(this._removeDragEffect,this));
        },
        _customView:function(options) {
            if(options.model.get("placeholder",false)) {
                return new PlaceholderModel(options);
            }
            return new options.model.attributes.base.component(options);
        },

        _dragOverEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent
            var data = this._getCurrentDragData(e)

            if (this.dragOver(data, e.dataTransfer, e) !== false) {
                if (e.preventDefault) e.preventDefault()
                e.dataTransfer.dropEffect = 'copy' // default
            }
        },

        _dragEnterEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent
            if (e.preventDefault) e.preventDefault()
        },

        _dragLeaveEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent
            var data = this._getCurrentDragData(e)
            this.dragLeave(data, e.dataTransfer, e)
        },

        _dropEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent
            var data = this._getCurrentDragData(e)

            if (e.preventDefault) e.preventDefault()
            if (e.stopPropagation) e.stopPropagation() // stops the browser from redirecting

            if (this._draghoverClassAdded) this.$el.removeClass("active-drag-extra")

            this.drop(data, e.dataTransfer, e)
        },

        _getCurrentDragData: function (e) {
            var data = null
            if (window._backboneDragDropObject) data = window._backboneDragDropObject
            return data
        },
        placeholderAdded:false,
        moveobject:false,

        dragOver: function (data, dataTransfer, e) { // optionally override me and set dataTransfer.dropEffect, return false if the data is not droppable
            this.$el.addClass("active-drag-extra");
            this._draghoverClassAdded = true;


            if(data.type==='n') {
                this.addPlaceholder(data.o.attributes);
            }else{
                this.moveobject=data.o;
            }

            //detect position
            var c=this.$el.children();
            var cYS=0;
            var cYE=0;
            var sorder=-1;
            if(e.target!==this.el) {
                for (var i = 0; i < c.length; i++) {
                    if(c[i]===e.target) {
                        sorder=i * 2 ;
                    }
                }
            }else {
                for (var i = 0; i <= c.length; i++) {
                    if (i === c.length) {
                        cYE = $(c[i - 1]).outerHeight() + cYS + 500;
                    } else {
                        cYE = $(c[i]).outerHeight() + cYS;
                    }

                    if (cYS <= e.offsetY && cYE >= e.offsetY) {
                        sorder = i * 2 + 1;
                        break;
                    }

                    cYS = cYE;
                }
            }
            if(!this.moveobject) {
                this.collection.where({placeholder: true}).map(_.bind(function (model) {
                    if(model.get("order")!=sorder) {
                        model.set("order", sorder);
                    }
                    this.collection.sort();
                }, this));
            }else{
                if(sorder!==-1) {
                    this.collection.map(_.bind(function (model, i) {

                        if(model.get("order")===0 && sorder===0) {
                            model.set("order",model.get("order")+20);
                            return;
                        }

                        if (model.get("order")  <= sorder ) {

                            model.set("order", model.get("order")-20 );
                        } else {
                            model.set("order", model.get("order") + 20);
                        }
                    }));

                    this.moveobject.set("order", sorder);
                    this.collection.sort();
                    this.collection._calcorder();
                }
            }

        },

        dragLeave: function (data, dataTransfer, e) { // optionally override me
            if (this._draghoverClassAdded) this.$el.removeClass("active-drag-extra");
            this.removePlaceholder();
        },
        addPlaceholder:function(base) {
            if(this.placeholderAdded)
                return;
            //console.log("p",base);
            this.placeholderAdded=this.collection.add({placeholder:true,order:-1,base:base});

        },
        removePlaceholder:function() {
            this.collection.where({placeholder:true}).map(_.bind(function(model){
                this.collection.remove(model);
            },this));
            this.placeholderAdded=false;
            this.moveobject=false;
        },
        _addDragEffect:function() {
            this.$el.addClass("active-drag");
        },
        _removeDragEffect:function() {
            this.$el.removeClass("active-drag");
        },
        t:0,
        drop: function (data, dataTransfer, e) {
            if(!this.moveobject) {
                this.collection.add({placeholder: false,order:this.placeholderAdded.get("order"),base:data.o.attributes});
            }else{
                this.collection._calcorder();
            }
            this.removePlaceholder();
        }
    });
});